import { LinkText, Stack, Text } from '@adc/parallax-component-library';
import { useNavigate } from '@tanstack/react-router';

export const NotFoundRoute = () => {
  const navigate = useNavigate();

  return (
    <Stack
      flex={1}
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      backgroundColor="$surface.background"
      padding="$6"
      gap="$4"
    >
      <Text type="$h1.default">404 Not Found</Text>
      <Text type="$bodyBase.medium">
        The page you are looking for does not exist.
      </Text>
      <LinkText
        target="_blank"
        type="$bodyBase.default"
        onPress={() => void navigate({ to: '/' })}
      >
        Go to Home
      </LinkText>
    </Stack>
  );
};
